// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentProcurementQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
}>;


export type DevelopmentProcurementQuery = { __typename?: 'Query', development: { __typename?: 'Development', id: string, name: string, internalBudgetEstimate: { __typename?: 'BidContract', id: string, latestRevision: { __typename?: 'BidContractRevision', id: string } } } };

export type DevelopmentProcurementPage_DevelopmentFragment = { __typename?: 'Development', id: string, name: string, internalBudgetEstimate: { __typename?: 'BidContract', id: string, latestRevision: { __typename?: 'BidContractRevision', id: string } } };

export const DevelopmentProcurementPage_DevelopmentFragmentDoc = gql`
    fragment DevelopmentProcurementPage_Development on Development {
  ...Named
  internalBudgetEstimate {
    id
    latestRevision {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const DevelopmentProcurementDocument = gql`
    query DevelopmentProcurement($developmentId: ID!) {
  development(id: $developmentId) {
    ...DevelopmentProcurementPage_Development
  }
}
    ${DevelopmentProcurementPage_DevelopmentFragmentDoc}`;

/**
 * __useDevelopmentProcurementQuery__
 *
 * To run a query within a React component, call `useDevelopmentProcurementQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentProcurementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentProcurementQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *   },
 * });
 */
export function useDevelopmentProcurementQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentProcurementQuery, DevelopmentProcurementQueryVariables> & ({ variables: DevelopmentProcurementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentProcurementQuery, DevelopmentProcurementQueryVariables>(DevelopmentProcurementDocument, options);
      }
export function useDevelopmentProcurementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentProcurementQuery, DevelopmentProcurementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentProcurementQuery, DevelopmentProcurementQueryVariables>(DevelopmentProcurementDocument, options);
        }
// @ts-ignore
export function useDevelopmentProcurementSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentProcurementQuery, DevelopmentProcurementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentProcurementQuery, DevelopmentProcurementQueryVariables>;
export function useDevelopmentProcurementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentProcurementQuery, DevelopmentProcurementQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentProcurementQuery | undefined, DevelopmentProcurementQueryVariables>;
export function useDevelopmentProcurementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentProcurementQuery, DevelopmentProcurementQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentProcurementQuery, DevelopmentProcurementQueryVariables>(DevelopmentProcurementDocument, options);
        }
export type DevelopmentProcurementQueryHookResult = ReturnType<typeof useDevelopmentProcurementQuery>;
export type DevelopmentProcurementLazyQueryHookResult = ReturnType<typeof useDevelopmentProcurementLazyQuery>;
export type DevelopmentProcurementSuspenseQueryHookResult = ReturnType<typeof useDevelopmentProcurementSuspenseQuery>;
export type DevelopmentProcurementQueryResult = ApolloReactCommon.QueryResult<DevelopmentProcurementQuery, DevelopmentProcurementQueryVariables>;